<section id="price" class="padded-section">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="center-heading">
          <h2>Precios</h2>
          <span class="center-line"></span>
        </div>
      </div>
    </div>
    <!--center heading row-->
    <div class="row">
      <div class="col-md-4 offset-sm-2 margin20 wow animated fadeInRight animated">
        <div class="price-wrap">
          <div class="price-title">
            <h4>Básico</h4>
          </div>
          <!--price title-->
          <div class="price-price">
            $1,000
            <span>Mensual</span>
          </div>
          <!--price price-->
          <div class="price-features">
            <ul class="list-unstyled">
              <li>Cuentas de Usuario</li>
              <li>Categorias y Subcategorias</li>
              <li>Ubicaciones</li>
              <li>Ingresos y Egresos</li>
              <li>Generación de recibos</li>
              <li>Cantidad Entregada diariamente</li>
              <li>Reportes</li>
            </ul>
          </div>
          <!--price features-->
          <div class="price-action">
            <a
              href="#"
              class="btn btn-theme-dark"
              href="https://wa.me/522225247311?text=Hola%20me%20gustaría%20saber%20más%20del%20programa%20básico"
              >Me interesa</a
            >
          </div>
          <!--price action-->
        </div>
        <!--price-wrap-->
      </div>
      <!--price col-->
      <div class="col-md-4 margin20 wow animated fadeInRight animated">
        <div class="price-wrap">
          <div class="price-title">
            <h4>Agenda</h4>
          </div>
          <!--price title-->
          <div class="price-price">
            $1,300
            <span>Mensual</span>
          </div>
          <!--price price-->
          <div class="price-features">
            <ul class="list-unstyled">
              <li>Cuentas de Usuario</li>
              <li>Categorias y Subcategorias</li>
              <li>Ubicaciones</li>
              <li>Ingresos y Egresos</li>
              <li>Generación de recibos</li>
              <li>Cantidad Entregada diariamente</li>
              <li>Reportes</li>
              <li>Agenda</li>
            </ul>
          </div>
          <!--price features-->
          <div class="price-action">
            <a
              href="#"
              href="https://wa.me/522225247311?text=Hola%20me%20gustaría%20saber%20más%20del%20programa%20completo"
              target="_blank"
              rel="noopener"
              class="btn btn-theme-dark"
              >Me interesa</a
            >
          </div>
          <!--price action-->
        </div>
        <!--price-wrap-->
      </div>
      <!--price col-->
    </div>
  </div>
</section>
<!--pricing-->
